// Centralized API base URL selection
// - Uses REACT_APP_API_URL when provided.
// - Falls back to localhost during local dev.
// - Falls back to production API when served from a non-localhost origin.
const isLocalHost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

export const API_URL =
  process.env.REACT_APP_API_URL ||
  (isLocalHost ? 'http://localhost:5000/api' : 'https://verp.peerapat.com/api');
